/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CurrencyResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class Currencies<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags currencies
   * @name FindAll
   * @request GET:/currencies
   * @secure
   */
  findAll = (params: RequestParams = {}) =>
    this.request<CurrencyResponse[], any>({
      path: `/currencies`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
